module.exports = __webpack_public_path__ + "cauim.4d16.png";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/cauim.png
// module id = ./src/_asset/sources/assets/images/cauim.png
// module chunks = main